import { Injector } from "@angular/core";

export class InjectorProvider {
  static injector: Injector;
}



// WEBPACK FOOTER //
// ./src/providers/injector/injector.ts